import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectLoading } from "src/modules/notification/redux";
import BranchSelectComponent from "./branchSelect.component";
import { getBranchListByProduct } from "../../../redux/action/companies.action";

function BranchSelectContainer({
  placeholder,
  handleBranchChange,
  selectedBranch,
  disabled,
  selectedProduct,
}) {
  const dispatch = useDispatch();
  const isFetching = useSelector((state) =>
    selectLoading(state, getBranchListByProduct.typePrefix)
  );
  const dropdown = useSelector((state) => state.companies.branchDropdown.list);
  const isError = useSelector(
    (state) => state.companies.branchDropdown.isError
  );

  const getData = () => {
    dispatch(
      getBranchListByProduct({
        productUuid: selectedProduct.product_uuid,
      })
    );
  };

  useEffect(() => {
    if (selectedProduct) getData();
  }, [selectedProduct]);

  return (
    <BranchSelectComponent
      selectedBranch={selectedBranch}
      placeholder={placeholder}
      branchDropdown={dropdown}
      isFetching={isFetching}
      handleBranchChange={handleBranchChange}
      isError={isError}
      disabled={disabled}
    />
  );
}

export default BranchSelectContainer;
